import {readApiModel} from '../../helpers/apiHelpers';
import {ApiIncident, IncidentModel} from '../../models/api/incidentModel';
import {IncidentsConnector} from './incidentsConnector';

const rawIncidents = [
  {
    name: 'No issues',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nbb7',
    incident_updates: [{body: 'This is a message'}],
    impact: 'none',
  },
  {
    name: 'Some Charles Minor issues',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nbb8',
    incident_updates: [{body: 'We are currently looking into this'}],
    impact: 'minor',
  },
  {
    name: 'Some major issue',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nbb9',
    incident_updates: [{body: 'We are currently monitoring this major issue'}],
    impact: 'major',
  },
  {
    name: 'Critical issues',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nb10',
    incident_updates: [{body: 'This critical issue is resolved'}],
    impact: 'critical',
  },
];

const partnerIncidents = [
  {
    name: 'Some Charles Minor issues [partner]',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nbb11',
    incident_updates: [
      {
        body: "If you're reading this, something is broken and you should raise the issue. Company id doesn't match => [1050|48940|684135]",
      },
    ],
    impact: 'minor',
  },
  {
    name: 'Some major issue with 0365 imports [11|1050|48940|684135] [partner]',
    shortlink: 'http://stspg.io/f3d1dabf7',
    id: '8hlvrvf5nbb12',
    incident_updates: [{body: 'This is an issue on Microsoft side - appears only for this company'}],
    impact: 'major',
  },
];

export class LocalIncidents implements IncidentsConnector {
  constructor(isPartnerStatusPage?: boolean) {
    this.incidents = rawIncidents.map((i) => readApiModel(ApiIncident, i));
    this.partnerIncidents = partnerIncidents.map((i) => readApiModel(ApiIncident, i));
    this.isPartnerStatusPage = isPartnerStatusPage;
  }

  private readonly incidents: ReadonlyArray<IncidentModel>;
  private readonly partnerIncidents: ReadonlyArray<IncidentModel>;
  private readonly isPartnerStatusPage: boolean | undefined;

  async fetchIncidentsAsync() {
    return this.isPartnerStatusPage ? this.partnerIncidents : this.incidents;
  }
}
